<div (click)="$event.preventDefault()" *ngIf="blockInput" class="fullscreen-blocker"></div>

<app-input-layout style="flex-direction: column; margin: auto;">
	<span style="display: flex; justify-content: center; align-items: center; column-gap: 1em; padding: 1em 0 0 0;">
		<mat-card-title class="titleContainer">{{ "MAIN_APP_SETTINGS.AppEinstellungen" | translate }}</mat-card-title>
		<button (click)="startDBControl()" class="fabButton" color="primary" mat-mini-fab>
			<fa-icon [icon]="faDatabase"></fa-icon>
		</button>
	</span>

    <mat-accordion>
        <div style="position: relative;">
            <button (clicked)="speedMenuClicked($event)" *ngIf="showNav" [items]="menuItems" closeIconCss="e-icons e-close" ejs-speeddial id="speedDialMenu" openIconCss="e-icons e-menu"
                    position="TopRight" style="top: 60px;"></button>
        </div>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.offlineDaten" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div style="display:flex; flex-direction: column; row-gap:0.5em;">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title class="block2_title">
                            {{ "MAIN_APP_SETTINGS.downloadedObjects" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="offline-object-list">
                        <div *ngFor="let offlineObject of offlineObjects" class="row">
                            <div class="obj-nr">{{ offlineObject.objectNumber }}</div>
                            <div class="obj-desc">{{ offlineObject.description }}</div>
                        </div>
                    </div>
                </mat-expansion-panel>

                @let docCount = (nrOfDocs | async);
                @if (docCount && docCount > 0) {
                    <div>
                        <h4> {{ docCount + ' ' + ((docCount === 1 ? "MAIN_APP_SETTINGS.SYNC_DOCUMENTS.single" : "MAIN_APP_SETTINGS.SYNC_DOCUMENTS.multiple") | translate) }}</h4>
                        <button (click)="uploadLocalDocuments()" mat-raised-button [disabled]="!helperService.isWebServiceAvailable()">{{ "MAIN_APP_SETTINGS.SYNC_DOCUMENTS.sync_button" | translate }}
                        </button>
                    </div>
                } @else {
                    <div>
                        <h4>{{ "MAIN_APP_SETTINGS.SYNC_DOCUMENTS.no_documents" | translate }}</h4>
                        <button mat-raised-button [disabled]="true">{{ "MAIN_APP_SETTINGS.SYNC_DOCUMENTS.sync_button" | translate }}</button>
                    </div>
                }
                <div>
                    <h4>{{ "MAIN_APP_SETTINGS.datenDownload" | translate }}</h4>
                    <button (click)="webEditionImport()" mat-raised-button>Import</button>
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.benutzerEinstellungen" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div>
                <div>
                    <mat-card appearance="outlined" class="mat-elevation-z4">
                        <mat-checkbox (change)="setTreeSorting($event.checked)" [checked]="webUserConfig.sortTreeView" style="width: 60%">
                            {{ "MAIN_APP_SETTINGS.SortTreeView" | translate }}
                        </mat-checkbox>
                        <mat-checkbox (change)="setShowStatusColorInTree($event.checked)" [checked]="currentUserConfig()?.showObjectStatusColorInTree" style="width: 60%">
                            {{ "MAIN_APP_SETTINGS.ShowObjectStatusColorInTree" | translate }}
                        </mat-checkbox>

                        <div style="width: 60%">
                            <mat-form-field appearance="fill" style="width: 200px">
                                <mat-label>{{
                                        "MAIN_APP_SETTINGS.startseite" | translate
                                    }}
                                </mat-label>
                                <mat-select (selectionChange)="dropdownStartPageChange($event)" [(value)]="startPage">
                                    <mat-option *ngFor="let site of startSites" [value]="site.value">
                                        {{ site.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <table style="width: 160px">
                            <tr>
                                <td>
                                    {{ "SETTINGS.CalenderTime" | translate }}
                                </td>
                                <td>
                                    <mat-form-field style="width: 75px">
                                        <input (input)="onGridStartChange($event)" [(ngModel)]="timeGridStart" matInput placeholder="{{
                        'MAIN_APP_SETTINGS.zeitrasterStart' | translate
                      }}" type="time"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field style="margin: 0 0 0 10px; width: 75px">
                                        <input (input)="onGridEndChange($event)" [(ngModel)]="timeGridEnd" matInput placeholder="{{
                        'MAIN_APP_SETTINGS.zeitrasterEnde' | translate
                      }}" type="time"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{ "SETTINGS.ServiceAppTimes" | translate }}
                                </td>
                                <td>
                                    <mat-form-field style="width: 75px">
                                        <input (input)="onWorkDayStartChange($event)" [(ngModel)]="timeWorkDayStart" matInput placeholder="{{
                        'MAIN_APP_SETTINGS.arbeitstagStart' | translate
                      }}" type="time"/>
                                    </mat-form-field>
                                </td>
                                <td>
                                    <mat-form-field style="margin: 0 0 0 10px; width: 75px">
                                        <input (input)="onWorkDayEndChange($event)" [(ngModel)]="timeWorkDayEnd" matInput placeholder="{{
                        'MAIN_APP_SETTINGS.arbeitstagEnde' | translate
                      }}" type="time"/>
                                    </mat-form-field>
                                </td>
                            </tr>
                        </table>
                    </mat-card>
                </div>
            </div>
            <mat-form-field style="margin-top: 1rem">
                <mat-label> {{ "SETTINGS.Sprache" | translate }}</mat-label>
                <mat-select [formControl]="languageForm">
                    <mat-option value="de">Deutsch</mat-option>
                    <mat-option value="fr">Französisch</mat-option>
                </mat-select>
            </mat-form-field>

            <ng-container *ngIf="showOrderFilter">
                <mat-form-field style="margin-top: 1rem">
                    <mat-label> {{ "MAIN_APP_SETTINGS.ORDER_FILTER.text" | translate }}</mat-label>
                    <input #OrderFilterValue [disabled]="true" matInput/>
                </mat-form-field>
            </ng-container>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.berechtigungen" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div *ngIf="userHasGroups">
                {{ "MAIN_APP_SETTINGS.zugeordneteBenutzergruppen" | translate }}
                <mat-list>
                    <mat-list-item *ngFor="let group of dbBenutzerGruppen">
                        <mat-icon>arrow_right</mat-icon>
                        {{ group.gruppe }}
                    </mat-list-item>
                </mat-list>
            </div>
            <div class="control-section">
                <ejs-grid #gridRechte [allowGrouping]="true" [allowSorting]="true" [dataSource]="dataSourceBenutzerRechte" [groupSettings]="groupOptions" [sortSettings]="sortOptions" height="300">
                    <e-columns>
                        <e-column field="GroupOrder" headerText="Rechtegruppe">
                            <ng-template #groupSettingsCaptionTemplate let-data>
                                {{ groupTemplateFn(data) }}
                            </ng-template>
                        </e-column>

                        <e-column field="Rechtbeschreibung" headerText="Berechtigung"></e-column>
                        <e-column field="HatRecht" headerText="Benutzer" textAlign="Center" type="boolean" width="150">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                        <e-column [visible]="userHasGroups" field="HatRecht" headerText="Gruppe" textAlign="Center" type="boolean" width="150">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatGruppenRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                        <e-column [visible]="userHasGroups" field="HatRecht" headerText="Effektiv" textAlign="Center" type="boolean" width="150">
                            <ng-template #template let-data>
                                <div>
                                    <ejs-checkbox #checkbox [checked]="data.HatEffektivRecht" [disabled]="true"></ejs-checkbox>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.serviceApp" | translate }}
                </mat-panel-title>
                <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>

            <h4>{{ "MAIN_APP_SETTINGS.datendownload" | translate }}</h4>
            {{
                "MAIN_APP_SETTINGS.dieserDownloadBeinhaltetFolgendeneDaten" | translate
            }}:<br/>
            - {{ "MAIN_APP_SETTINGS.stammdaten" | translate }}<br/>
            - {{ "MAIN_APP_SETTINGS.objekte" | translate }}<br/>
            - {{ "MAIN_APP_SETTINGS.checklisten" | translate }}<br/>
            - {{ "MAIN_APP_SETTINGS.dokumente" | translate }}<br/>
            <br/>
            <button (click)="serviceAppImport()" mat-raised-button>
                {{ "MAIN_APP_SETTINGS.import" | translate }}
            </button>

            <div [hidden]="hideLoading |async">
                <br/>
                <mat-progress-bar mode="determinate" value="{{ importProgress | async }}"></mat-progress-bar>
            </div>
            <br/>
            {{ "MAIN_APP_SETTINGS.anzahlDokumente" | translate }} ({{ downloadedDocuments | async }} / {{ totalDocuments | async }})
            <br/>
            <h4>{{ "MAIN_APP_SETTINGS.stammdaten" | translate }}</h4>
            <div *ngIf="sa_Config">
                <table style="width: 80%; max-width: 700px">
                    <tr>
                        <th>
                            {{ "MAIN_APP_SETTINGS.bezeichnung" | translate }}
                        </th>
                        <th>{{ "MAIN_APP_SETTINGS.konfiguration" | translate }}</th>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.spesenartMatEinkauf" | translate }}</td>
                        <td>
							<span *ngIf="sa_DefaultMatExpense">{{
                                    sa_DefaultMatExpense!.expenseID +
                                    " " +
                                    sa_DefaultMatExpense!.description
                                }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.kostenstelleMatEinkauf" | translate }}</td>
                        <td>
							<span *ngIf="sa_DefaultMatCostCenter">{{
                                    sa_DefaultMatCostCenter!.costCenterID +
                                    " " +
                                    sa_DefaultMatCostCenter!.description
                                }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.checklisteUebermitteln" | translate }}
                        </td>
                        <td>{{ sa_Config!.checklisteUebermitteln }}</td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.serviceIDGenerieren" | translate }}
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.serviceIDGenerieren" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.wlArticleSend" | translate }}</td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.werkstofflistenArtikel_uebermitteln" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.standardObjekt" | translate }}</td>
                        <td>
							<span *ngIf="sa_DefaultObject">{{
                                    sa_DefaultObject!.objectNumber + " " + sa_DefaultObject!.objDescription
                                }}</span>
                        </td>
                    </tr>
                </table>
            </div>

            <h4>{{ "MAIN_APP_SETTINGS.benutzer&MandantEinstellungen" | translate }}</h4>
            <div *ngIf="sa_Config">
                <table style="width: 80%; max-width: 600px">
                    <tr>
                        <th>
                            {{ "MAIN_APP_SETTINGS.bezeichnung" | translate }}
                        </th>
                        <th>{{ "MAIN_APP_SETTINGS.benutzer" | translate }}</th>
                        <th>{{ "MAIN_APP_SETTINGS.mandant" | translate }}</th>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.speseneintrag" | translate }}</td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_ShowExpense" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.speseneintrag" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.kulanz" | translate }}</td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser()!.sA_ShowGoodwill" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.kulanz" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.datenLöschenNach(Tagen)" | translate }}
                        </td>
                        <td>{{ currentUser().sA_DeleteDataAfter }}</td>
                        <td>{{ sa_Config!.deleteDataAfterDays }}</td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.preiseInRapportAnzeigen" | translate }}
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_ShowPrices" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.preiseInRapportAnzeigen" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.waehrungInRapportAnzeigen" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.waehrungInRapportAnzeigen" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.checklisteAusfüllen" | translate }}</td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_EditChecklist" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.checklisteAusfuellen" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.kurzzeichenFürStunden" | translate }}</td>
                        <td>{{ currentUser().sA_HoursText }}</td>
                        <td>{{ sa_Config!.kurzzeichenStunden }}</td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.zeitenRundenAufMinuten" | translate }}
                        </td>
                        <td>{{ currentUser().sA_RoundTimes }}</td>
                        <td>{{ sa_Config!.zeitenRundung }}</td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.kleinmaterialAufArbeit" | translate }}
                        </td>
                        <td>{{ currentUser().sA_PercentageIncidentals }}</td>
                        <td>{{ sa_Config!.kleinmaterialArbeitInProzent }}</td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.mwst-Satz" | translate }}</td>
                        <td>{{ currentUser().sA_PercentageVAT }}</td>
                        <td>{{ sa_Config!.mwStSatz }}</td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.standardKostenstelle" | translate }}</td>
                        <td>
							<span *ngIf="sa_DefaultUserCostCenter">{{
                                    sa_DefaultUserCostCenter!.costCenterID +
                                    " " +
                                    sa_DefaultUserCostCenter!.description
                                }}</span>
                        </td>
                        <td>
							<span *ngIf="sa_DefaultCostCenter">{{
                                    sa_DefaultCostCenter!.costCenterID +
                                    " " +
                                    sa_DefaultCostCenter!.description
                                }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.arbeitsortAnzeigen" | translate }}</td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_ShowWorkplace" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.arbeitsortAnzeigen" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ "MAIN_APP_SETTINGS.dashboardIntervall" | translate }}</td>
                        <td>{{ currentUser().sA_DashboardIntervall }}</td>
                        <td>{{ sa_Config!.dashboardIntervall }}</td>
                    </tr>
                    <tr>
                        <td>
                            {{
                                "MAIN_APP_SETTINGS.zeitenNichtAnZeitkontrolleUbermitteln"
                                    | translate
                            }}
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_Dontsendtimestotimecontrol" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.zeitenNichtAnZeitkontrolleSenden" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.spesenInRapportAnzeigen" | translate }}
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_ShowExpenseInRapport" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.spesenInRapportAnzeigen" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.fotosAnServiceAppUbermitteln" | translate }}
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="!!currentUser().sA_ShowExpenseInRapport" [disabled]="true"></ejs-checkbox>
                        </td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.fotosTyp9AnSASenden" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.zeiterfObjektAuswahlViaEingabe" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.zeiterfObjektAuswahlViaEingabe" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.verschiebungVonTerminenErlauben" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <ejs-checkbox #checkbox [checked]="sa_Config!.verschiebungVonTerminenErlauben" [disabled]="true"></ejs-checkbox>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.syncInPast" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <mat-form-field>
                                <mat-label>{{ "MAIN_APP_SETTINGS.syncInPast" | translate }}</mat-label>
                                <input (change)="changeInPast($event)" [(ngModel)]="syncInPast" matInput/>
                            </mat-form-field>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.syncInFuture" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <mat-form-field>
                                <mat-label>{{ "MAIN_APP_SETTINGS.syncInFuture" | translate }}</mat-label>
                                <input (change)="changeInFuture($event)" [(ngModel)]="syncInFuture" matInput/>
                            </mat-form-field>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.notClosedOrder" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <input (change)="checked($event)" [(ngModel)]="notClosedOrder" type="checkbox"/>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            {{ "MAIN_APP_SETTINGS.ShowUnplannedOrders" | translate }}
                        </td>
                        <td></td>
                        <td>
                            <form [formGroup]="serviceAppSettingsForm">
                                <mat-checkbox formControlName="showTime"></mat-checkbox>
                            </form>
                        </td>
                    </tr>
                </table>
            </div>
            <div><br/><br/></div>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title class="block2_title">
                    {{ "MAIN_APP_SETTINGS.backup" | translate }}
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="backup">
                <div (click)="downloadBackup()" class="download btn">
                    {{ "MAIN_APP_SETTINGS.downloadBackup" | translate }}
                </div>

                <div style="display: flex; flex-direction: row;">
                    <div>
                        <div #vinbkupUpload class="upload" style="width:250px; display: flex;">
                            <label for="vinbkInput" style="margin: auto; align-self: center;">{{ getPath }}</label>
                            <input #vinbkInput (change)="onChange($event)" (dragover)="onDragOver($event)" (drop)="onDrop($event);" id="vinbkInput"
                                   style="height: 100%; width:100%; opacity: 0; position: absolute; left: 0; top: 0; right: 0; bottom: 0;" type="file">
                        </div>
                    </div>
                    <button #vinbkApply (click)="loadBackup()" (dragover)="onDragOver($event)" (drop)="onDrop($event);" class="btn badFile">
                        {{
                            vinbkInput.value ? ("MAIN_APP_SETTINGS.applyBackup" | translate) : ("MAIN_APP_SETTINGS.uploadBackup" |
                                translate)
                        }}
                    </button>
                </div>
            </div>

            <div class="server-backup">
                <h4>{{ "MAIN_APP_SETTINGS.serverBackup" | translate }}</h4>
                @let backupInfo = serverBackupInfo();
                @if (backupInfo?.available) {
                    <div class="server-backup-status">
                        {{ "MAIN_APP_SETTINGS.serverBackupAvailable" | translate }}: {{ backupInfo!.createdAt | date:'dd.MM.yyyy HH:mm' }}
                    </div>
                } @else {
                    <div class="server-backup-status">{{ "MAIN_APP_SETTINGS.noServerBackup" | translate }}</div>
                }
                <div style="display: flex; flex-direction: row; column-gap: 0.5em;">
                    <button (click)="downloadServerBackup()" mat-raised-button [disabled]="!helperService.isWebServiceAvailable() || !backupInfo?.available">
                        {{ "MAIN_APP_SETTINGS.downloadServerBackup" | translate }}
                    </button>
                    <button (click)="restoreServerBackup()" mat-raised-button color="warn" [disabled]="!helperService.isWebServiceAvailable() || !backupInfo?.available">
                        {{ "MAIN_APP_SETTINGS.restoreServerBackup" | translate }}
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="panel-content device-settings">
            <mat-expansion-panel-header class="block2_title">
                <mat-panel-title class="block2_title">
                    <div>{{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.TITLE" | translate }}</div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="treeViewSettingsForm">
                <div>
                    <mat-checkbox (change)="updateDeviceSettingsFlag($event, 'pfd_dialog_objects')"
                                  [checked]="pfdDialogObjects">{{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.OBJECT_PDFVIEWER_DIALOG.text" | translate }}
                    </mat-checkbox>
                </div>
                <div>
                    <mat-checkbox formControlName="activeTouchBubble">{{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.TOUCH_BALL.text" | translate }}
                    </mat-checkbox>
                </div>
                <div>
                    <mat-form-field formControlName="width">
                        <mat-label>{{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.WIDTH_TREE.text" | translate }}</mat-label>
                        <input formControlName="width" matInput placeholder="30%" readonly>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field formControlName="height">
                        <mat-label>{{ "MAIN_APP_SETTINGS.DEVICE_SETTINGS.HEIGHT_SEARCH.text" | translate }}</mat-label>
                        <input formControlName="height" matInput placeholder="30" type="number" min="10" max="80">
                    </mat-form-field>
                </div>
            </form>

            <div *ngIf="svcVinavonUpdate.newVersionFound | async">
				<span>
					<button (click)="svcVinavonUpdate.askUserToDoUpdate()" class="btn-block" color="warn" mat-stroked-button>Update vinavon</button>
				</span>
            </div>
            <div style="display: flex; flex-direction: column">
                <div> {{ device.ua }}</div>
                <div> {{ device.device.model }} | {{ device.device.type }}</div>
                <div> {{ device.browser.name }} | {{ device.browser.version }}</div>
                <div> orientation: {{ device.device.orientation }}</div>
                <div> H: {{ device.device.height }} X W: {{ device.device.width }}</div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</app-input-layout>
